import { Store } from "vuex";

export class SettingsHelper {
    $store: Store<any>;

    constructor(store: Store<any>) {
        this.$store = store;
    }

    public static settingsHash = "#settings";

    getStringFromObject(data: any): string | null {
        try {
            return JSON.stringify(data);
        }
        catch (e) {
            this.$store.dispatch('reportException', e);
            return null
        }
    }

    getObjectFromString(string: string): any | null {
        try {
            return JSON.parse(string || '{}');
        }
        catch (e) {
            this.$store.dispatch('reportException', e);
            return {}
        }
    }

    objectSameAsString(object: Record<string, any>, originString: string) {
        return originString === this.getStringFromObject(object) ?? '';
    }
}